import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays, addSeconds, format, intervalToDuration } from "date-fns";
import Status from "../../../components/status";
import { Button, Pagination, Spin, DatePicker, Select } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import {
  getValue,
  getDate,
  formatarDuracaoCompleta,
} from "../../../services/functions";
import CountUp from "react-countup";
import { Card, Message, ViewInput } from "../../../GlobalStyles";
import { useQuery } from "../../../hooks/Location";

export default function SolicitacoesAdmin() {
  const navigate = useNavigate();
  const query = useQuery();
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [user_id, setUser_id] = useState(query.get("cliente") || "");
  const [collaborator_id, setCollaborator_id] = useState(
    query.get("tecnico") || "",
  );
  const [status, setStatus] = useState("");
  const [averageTime, setAverageTime] = useState(0);
  const [totalServices, setTotalServices] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    loadingUsersAndTecnicos();
  }, []);

  useEffect(() => {
    loadingOSs(startDate, endDate, user_id, status, collaborator_id, page);
  }, [startDate, endDate, status, collaborator_id, user_id, page]);

  async function loadingUsersAndTecnicos() {
    await api
      .get(`/users?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        setCollaborators(response.data.collaborators);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadingOSs(
    startDate,
    endDate,
    user_id,
    status,
    collaborator_id,
    page,
  ) {
    setLoading(true);
    await api
      .get(
        `/orders-admin/?startDate=${startDate}&endDate=${endDate}&page=${page}&status=${status}${
          collaborator_id && `&collaborator_id=${collaborator_id}`
        }${user_id && `&user_id=${user_id}`}`,
      )
      .then((response) => {
        setTotalValue(response.data.totalValue);
        setTotalServices(response.data.totalServices);
        setAverageTime(response.data.averageTime);
        setOrders(response.data.orders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>Todas OSs</h1>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={ordersTotal} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: "100%", maxWidth: 265 }}>
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                  setPage(0);
                }}
                allowClear={false}
                onOk={() => {}}
              />
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Técnicos</p>
              <Select
                placeholder="selecionar técnico"
                value={collaborator_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setCollaborator_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Técnicos</Select.Option>
                {collaborators.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Status</Select.Option>
                <Select.Option value="andamento">Em andamento</Select.Option>
                <Select.Option value="finalizado">Finalizado</Select.Option>
                <Select.Option value="alteracao">
                  Alteração Solicitada
                </Select.Option>
                <Select.Option value="pendente">
                  Documentação Pendente
                </Select.Option>
                <Select.Option value="pagamento">
                  Aguardando Pagamento
                </Select.Option>
                <Select.Option value="recusado">Recusado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
                <Select.Option value="aberto">Aguardando Técnico</Select.Option>
              </Select>
            </ViewInput>
          </div>
          {orders.length == 0 && (
            <Message>Nenhuma Ordem de Serviço encontrada</Message>
          )}
          {!!ordersTotal && (
            <>
              <p className="resumo">
                <strong>{ordersTotal}</strong> OSs e{" "}
                <strong>{totalServices}</strong> serviços solicitados
              </p>
              {!!averageTime && (
                <p className="resumo" style={{ marginTop: 10 }}>
                  Tempo médio para conclusão das OSs:{" "}
                  {formatarDuracaoCompleta(
                    intervalToDuration({
                      start: new Date(),
                      end: addSeconds(new Date(), averageTime),
                    }),
                  )}
                </p>
              )}
              <p className="resumo" style={{ marginTop: 10 }}>
                <strong>{getValue(totalValue || 0)}</strong> total
              </p>
              <p className="resumo" style={{ marginTop: 5, marginBottom: 20 }}>
                <strong>{getValue(totalValue * 3 || 0)}</strong> média de
                faturamento
              </p>
            </>
          )}
          <div className="orders">
            {orders.map((item) => {
              return (
                <div className="order">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.urgent && (
                      <Status
                        isUrgent={true}
                        style={{
                          marginRight: 10,
                          marginBottom: 7,
                          flexFlow: "nowrap",
                        }}
                      />
                    )}
                    {item.name && (
                      <p
                        style={{ width: "100%", fontSize: 11, marginBottom: 8 }}
                      >
                        {item.name}
                      </p>
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="title">{("0000" + item.id).slice(-4)} </p>
                    <p
                      className="back"
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      {item.totalServices} serviços
                    </p>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ minWidth: 250, marginRight: 50 }}>
                      <p className="title">Status</p>
                      <Status status={item.status} urgent={item.urgent} />
                    </div>
                    <div className="item">
                      <p className="title">Última atualização</p>
                      <p
                        className="back"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                      </p>
                    </div>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate("/admin/os/" + item.id);
                    }}
                  >
                    Detalhes
                  </Button>

                  {!!item.averageTime && (
                    <p style={{ width: "100%", fontSize: 11, marginTop: 10 }}>
                      OS concluida em{" "}
                      {formatarDuracaoCompleta(
                        intervalToDuration({
                          start: new Date(),
                          end: addSeconds(new Date(), item.averageTime),
                        }),
                      )}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={ordersTotal}
          />
        </>
      )}
    </Container>
  );
}
